import type { TGetLastTruckTrailerPairsRes, TTransportSubtype, TTransportType } from 'api/swagger';

export const TransportType: Record<TTransportType, TTransportType> = {
  truck: 'truck',
  trailer: 'trailer',
};

export enum ETripAssignment {
  all = 'all',
  with_trip = 'with_trip',
  without_trip = 'without_trip',
}

export type TrailerSubTypeKeys = Extract<TTransportSubtype, 'mega' | 'platform' | 'roadtrain_trailer'>;
export type TruckSubTypeKeys = Exclude<TTransportSubtype, 'mega' | 'platform' | 'roadtrain_trailer'>;

export const TrailerSubTypes: Record<TrailerSubTypeKeys, string> = {
  mega: 'Mega Trailer',
  platform: 'Platform Trailer',
  roadtrain_trailer: 'Roadtrain Trailer',
};

export const TruckSubTypes: Record<TruckSubTypeKeys, string> = {
  van: 'Van',
  truck_head: 'Truck Head',
  roadtrain: 'Roadtrain',
  truck_10t: 'Truck 10t',
};

export const TransportSubTypes: Record<TTransportSubtype, string> = {
  ...TrailerSubTypes,
  ...TruckSubTypes,
};

export type TTruckTrailerPairsMap = Record<number, TGetLastTruckTrailerPairsRes>;
